import { AppId, FCX, ProductLogo, usePlatformContext, usePlatformFeatureFlag } from "@datassential/platform-ui-lib";
import MacsList from "../MacsList/MacsList";
import MacsListTableObsolete from "../MacsListObsolete";
import { MAC_NEW_ORIGIN_FLAG } from "@apiHooks/useMacs.constants";

const MacsListSwitch: FCX = () => {
    const { isUserInfoLoaded } = usePlatformContext();
    const isNewOriginEnabled = usePlatformFeatureFlag(MAC_NEW_ORIGIN_FLAG);

    if (!isUserInfoLoaded) {
        return (
            <div className="TrendingNow__spinner">
                <ProductLogo appId={AppId.Snap} type="regular"/>
            </div>
        );
    }

    return isNewOriginEnabled ? <MacsList/> : <MacsListTableObsolete/>;
};

export default MacsListSwitch;
